module.exports = __webpack_public_path__ + "img/cabernetSauvignon-reserva.e93a8f50.jpg";